import globalValidators, {
    FieldValidator,
    composeValidators
} from '../../validators';
import { ValidatorNames } from '../../validators/types';

const getValidateFunction = (
    validatorNames?: ValidatorNames
): FieldValidator | undefined => {
    if (!validatorNames) {
        return undefined;
    }

    if (!Array.isArray(validatorNames)) {
        return globalValidators[validatorNames];
    }

    const listValidators = validatorNames.map(
        validatorName => globalValidators[validatorName]
    );

    return composeValidators(...listValidators);
};

export default getValidateFunction;
